class DebugHelper {
	constructor(prefix) {
		this.prefix = prefix;
	}

	log(message = '', object = null, force = false, prefix = '') {
		if (!prefix) {
			prefix = this.prefix;
		}

		let debugMode = false;

		// Force debug mode with URL param
		if (debugMode === false) {
			const urlParams = new URLSearchParams(window.location.search);
			debugMode = urlParams.get('debug') === 'true';
		}

		if (force || debugMode) {
			console.debug(`LL ${prefix}: ${message}`);

			if (object) {
				console.debug(object);
			}
		}
	}
}

export default DebugHelper;
